import { MainTitle, Title } from "app/components/common";
import AnimatedBox from "app/components/common/AnimatedBox";
import i18n from "@microdoing/shared/i18n";
import React from "react";
import { StyleSheet, View } from "react-native";
import { widthPercentageToDP } from "react-native-responsive-screen";
import { useSelector } from "react-redux";
import {
  getCoachingDurationInMonths,
  getGoalsResult,
  getTotalDoneActions,
  getTotalDoneSessions,
} from "@microdoing/shared/services/coaching/selectors";
import SummaryRow from "./SummaryRow";

const styles = StyleSheet.create({
  main: {
    width: widthPercentageToDP("90%"),
    marginBottom: 15,
  },
});

const SummaryCoaching = ({}) => {
  const totalDurationInMonths = useSelector(getCoachingDurationInMonths);

  const totalDoneActions = useSelector(getTotalDoneActions);

  const totalDoneSessions = useSelector(getTotalDoneSessions);

  const goalsResult = useSelector(getGoalsResult);

  return (
    <AnimatedBox style={styles.main}>
      <MainTitle marginBottom="s">{i18n.t("summary")}</MainTitle>
      <SummaryRow
        title={i18n.t("summary-total-duration")}
        result={`${totalDurationInMonths} ${i18n.t("months")}`}
      />
      <SummaryRow title={i18n.t("summary-goals")} result={goalsResult} />
      <SummaryRow
        title={i18n.t("summary-done-actions")}
        result={totalDoneActions}
      />
      <SummaryRow
        title={i18n.t("summary-done-sessions")}
        result={totalDoneSessions}
      />
    </AnimatedBox>
  );
};

export default SummaryCoaching;
